<template>
  <div class="flow-day-preview-marker" ref="flow_block">
    <div class="p-2 text-center">
      <h4 class="m-0" >
        Days planned in advance
      </h4>
      <h4 class="m-0" v-if="daysPlannedInAdvance === 0">
        0 days <img src="https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/twitter/185/see-no-evil-monkey_1f648.png" style="height: 40px"/>
      </h4>
      <h4 class="m-0" v-if="daysPlannedInAdvance === 1">
        1 day <img src="https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/144/twitter/185/slightly-smiling-face_1f642.png" style="height: 40px"/>
      </h4>
      <h4 class="m-0" v-if="daysPlannedInAdvance === 2">
        2 days <img src="https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/144/twitter/185/smiling-face-with-sunglasses_1f60e.png" style="height: 40px"/>
      </h4>
      <h4 class="m-0" v-if="daysPlannedInAdvance === 3">
        3 or more days <img src="https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/twitter/185/rocket_1f680.png" style="height: 40px"/>
      </h4>
    </div>
  </div>
</template>

<script>
import moment from '@/moment-gp'
//import TimeSelector from "@/components/Elements/TimeSelectorInline";

export default {
  props: {
    dateTimestamp: {
      type: Number
    },
    dayplanner_sessions: {
      type: Object
    }
  },
  data: () => ({
  }),
  computed: {
    dateStringTomorrow() {
      return moment(this.dateTimestamp * 1000).add(1,'day')
    },
    daysPlannedInAdvance() {
      let daysPlannedInAdvance = 0
      // TODO: skip weekends?
      if (this.dayplanner_sessions) {
        let tmpDay = moment(this.dateTimestamp * 1000).startOf('day')
        for (let i = 0; i < 5; i++) {
          let dateString = tmpDay.format('YYMMDD')
          let nrSessions = this.dayplanner_sessions.itemsAsArray().filter(session => session.type !== 'START_DAY' && session.type !== 'END_DAY' && session.type !== 'NOT_PLANNED'  && session.type !== 'CURRENT_TIME' && session.type !== 'EXTERNAL_EVENT' && session.dateString === dateString).length
          if (nrSessions > 0) {
            daysPlannedInAdvance += 1
          }
          tmpDay.add(1,'day')
        }
      }
      return daysPlannedInAdvance
    },
  },
  methods: {
  },
  components: {
  }
}
</script>

<style>
.flow-day-preview-marker {
  position: relative;
  margin-bottom: 30px;
  cursor: ns-resize;
}
.flow-day-preview-marker > div {
  border-radius: 5px;
  background: white;
}
</style>
